export const getActiveTariffDaysLeft = (
  activeTariffExpiresAt: string
): string => {
  const expirationDate = new Date(activeTariffExpiresAt);
  const currentDate = new Date();
  const timeDiff = expirationDate.getTime() - currentDate.getTime();
  const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
  const filteredDaysLeft = daysLeft > 0 ? daysLeft : 0;

  const getDayWord = (days: number): string => {
    const lastDigit = days % 10;
    const lastTwoDigits = days % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
      return 'дней';
    }
    if (lastDigit === 1) {
      return 'день';
    }
    if (lastDigit >= 2 && lastDigit <= 4) {
      return 'дня';
    }
    return 'дней';
  };

  return `${filteredDaysLeft} ${getDayWord(filteredDaysLeft)}`;
};
